<template>
    <section class="shipments">
        <SubHeader
            :title="$t('pages.shipments.title')"
            :crumbs="textContent['crumbs']"
        />
        <div class="shipments__body">
            <v-tabs v-model="tab" align-with-title dense>
                <v-tab>{{ $t('pages.shipments.shipments') }}</v-tab>
                <v-tab>{{ $t('pages.shipments.shipmentItems') }}</v-tab>
            </v-tabs>

            <div class="shipments__tabs">
                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <div class="shipments__tab">
                            <ShipmentsOverview />
                        </div>
                    </v-tab-item>
                    <v-tab-item>
                        <div class="shipments__tab">
                            <ShipmentItemsList />
                        </div>
                    </v-tab-item>
                </v-tabs-items>
            </div>
        </div>
    </section>
</template>

<script>
import languageMixin from '@/mixins/language.mixin'
import SubHeader from '@/components/common/sub-header'
import ShipmentsOverview from '@/components/shipments/shipments-overview'
import ShipmentItemsList from '@/components/shipments/shipment-items-list.vue'

export default {
    name: 'Shipments',
    components: { SubHeader, ShipmentsOverview, ShipmentItemsList },
    mixins: [languageMixin],
    data: () => ({
        crumbs: [{ title: 'Home' }],
        tab: 0,
    }),
}
</script>

<style lang="scss" scoped>
.shipments {
    min-height: 100%;
    background: #fff;

    &__body {
        width: 100%;
        padding: 10px 15px 10px;
        min-height: 50px;
    }

    &__tabs {
        width: 100%;
    }

    &__tab {
        width: 100%;
        padding: 16px 0 0;
    }
}
</style>

